<template>
    <UICombobox
        class="languages-select"
        :model-value="selectedLocale"
        :options="options"
        label="name"
        track-by="value"
        :option-height="104"
        :searchable="false"
        :allow-empty="false"
        @update:model-value="switchLanguage"
    >
        <template #option="props">
            {{ $t(`locales.${props.option.value}`) }}
        </template>
    </UICombobox>
</template>

<script>
export default {
    name: 'LanguageSelect',
};
</script>

<script setup>
import { computed, inject } from 'vue';
import { useI18n } from 'vue-i18n';
import UICombobox from '@/components/ui/UICombobox/index.vue';
import Tr from '@/i18n/translation';

const emitter = inject('emitter');

const { t, locale } = useI18n();
const { supportedLocales } = Tr;

const selectedLocale = computed(() => ({ value: locale.value, name: t(`locales.${locale.value}`) }));

const options = supportedLocales.map(el => ({
    value: el,
    name: t(`locales.${el}`),
}));

const switchLanguage = async ev => {
    const newLocale = ev.value;
    await Tr.switchLanguage(newLocale);
    emitter.emit('change-languages', newLocale);
};
</script>

<style src="./styles.scss" lang="scss" scoped />
